import * as React from 'react';
import withIconSvg from '../helpers/withIconSvg';

const Icon: React.FC = (props) => (
	<svg
		height="21"
		width="24"
		viewBox="0 0 24 21"
		{...props}
	>
		<g>
			<path className="st0" d="M12,21c-0.2,0-0.3,0-0.4-0.1l-4-2c-0.5-0.2-0.7-0.8-0.4-1.3s0.8-0.7,1.3-0.4l3.6,1.8l3.6-1.8
				c0.5-0.2,1.1,0,1.3,0.4c0.2,0.5,0,1.1-0.4,1.3l-4,2C12.3,21,12.2,21,12,21z"/>
		</g>
		<g>
			<path className="st0" d="M12,17c-0.2,0-0.3,0-0.4-0.1l-2-1c-0.5-0.2-0.7-0.8-0.4-1.3s0.8-0.7,1.3-0.4l1.6,0.8l1.6-0.8
				c0.5-0.2,1.1,0,1.3,0.4s0,1.1-0.4,1.3l-2,1C12.3,17,12.2,17,12,17z"/>
		</g>
		<g>
			<path className="st0" d="M12,12.5c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.2
				c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.4,0.2-0.8,0.4-1.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1
				c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2
				c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.4-0.2,0.8-0.4,1.1c-0.1,0.1-0.1,0.1-0.2,0.2
				c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1C12.2,12.5,12.1,12.5,12,12.5z"/>
		</g>
		<g>
			<path className="st0" d="M5,16c-2.8,0-5-2.2-5-5c0-2.1,1.3-3.9,3.2-4.6C3.9,2.7,7.2,0,11,0c2,0,3.9,0.7,5.3,2c0.2,0,0.5,0,0.7,0
				c3.9,0,7,3.1,7,7c0,3-1.9,5.6-4.7,6.6c-0.5,0.2-1.1-0.1-1.3-0.6c-0.2-0.5,0.1-1.1,0.6-1.3C20.7,13,22,11.1,22,9c0-2.8-2.2-5-5-5
				c-0.3,0-0.5,0-0.8,0.1c-0.3,0.1-0.7-0.1-0.9-0.3C14.1,2.6,12.6,2,11,2C8,2,5.4,4.3,5.1,7.2C5,7.7,4.7,8,4.3,8.1C2.9,8.4,2,9.6,2,11
				c0,1.7,1.3,3,3,3c0.6,0,1,0.4,1,1S5.6,16,5,16z"/>
		</g>
	</svg>
);

export default withIconSvg(
	Icon,
	true,
	{
		tags: [
			'connect',
			'host',
			'pull',
			'remote',
		],
	},
);
